import { render, staticRenderFns } from "./footer-info.vue?vue&type=template&id=56b51e14&scoped=true&"
import script from "./footer-info.vue?vue&type=script&lang=js&"
export * from "./footer-info.vue?vue&type=script&lang=js&"
import style0 from "./footer-info.vue?vue&type=style&index=0&id=56b51e14&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b51e14",
  null
  
)

export default component.exports